import { Component, HostListener } from '@angular/core';
import {AuthService} from "../../../../services/auth/auth.service";
import {AppSettingService} from "../../../../services/app-setting/app-setting.service";

@Component({
  selector: 'app-verificator-navbar',
  templateUrl: './verificator-navbar.component.html',
  styleUrls: ['./verificator-navbar.component.scss']
})
export class VerificatorNavbarComponent {

  constructor(public authService: AuthService, public appSettingService: AppSettingService) {}

  isMobileMenuOpen = false;
  activeDropdown: string | null = null;

  ngOnInit() {
    console.log('NavbarComponent initialized');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.dropdown')) {
      this.activeDropdown = null;
      console.log('Dropdown closed by outside click');
    }
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    console.log('Mobile menu toggled:', this.isMobileMenuOpen);
  }

  closeMobileMenu() {
    this.isMobileMenuOpen = false;
    console.log('Mobile menu closed');
  }

  toggleDropdown(dropdownName: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    
    console.log('Toggle dropdown:', dropdownName, 'Current active:', this.activeDropdown);
    
    if (this.activeDropdown === dropdownName) {
      this.activeDropdown = null;
      console.log('Dropdown closed:', dropdownName);
    } else {
      this.activeDropdown = dropdownName;
      console.log('Dropdown opened:', dropdownName);
    }
  }

  isDropdownActive(dropdownName: string): boolean {
    const isActive = this.activeDropdown === dropdownName;
    console.log('Check dropdown active:', dropdownName, 'Result:', isActive);
    return isActive;
  }
}
